import React from 'react';
import { Link } from 'react-router-dom';

const HelpNewsBanner = () => (
  <Link to="/news" className="help-news-banner">
    <span className="help-news-banner__icon" aria-hidden="true">
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M4 5h13v14H6a2 2 0 0 1-2-2V5z" />
        <path d="M17 9h3v8a2 2 0 0 1-2 2" />
        <path d="M8 9h5M8 13h5" />
      </svg>
    </span>
    <span className="help-news-banner__text">
      <strong>아침 교육 뉴스</strong>
      <span>매일 아침 8시, 선생님께 필요한 교육 소식을 3분 안에 정리해 드려요</span>
    </span>
    <svg className="help-news-banner__chevron" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
      <path d="M9 18l6-6-6-6" />
    </svg>
  </Link>
);

export default HelpNewsBanner;
